var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircledArrowDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.23 13.2204L17.8392 14.8295L13.0117 19.6571L8.18412 14.8295L9.7933 13.2204L11.8738 15.3009V6.72461H14.1495V15.3009L16.23 13.2204Z",
    fill: "#63B67F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8621 22.0413C16.9741 26.9293 9.04912 26.9293 4.16112 22.0413C-0.726883 17.1533 -0.726883 9.22832 4.16112 4.34032C9.04912 -0.547684 16.9741 -0.547684 21.8621 4.34032C26.7501 9.22832 26.7501 17.1533 21.8621 22.0413ZM20.253 20.4322C16.2537 24.4314 9.76958 24.4314 5.7703 20.4322C1.77103 16.4329 1.77103 9.94878 5.7703 5.9495C9.76958 1.95023 16.2537 1.95023 20.253 5.9495C24.2522 9.94878 24.2522 16.4329 20.253 20.4322Z",
    fill: "#63B67F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircledArrowDown);
export default __webpack_public_path__ + "static/media/circled-arrow-down.54632b79.svg";
export { ForwardRef as ReactComponent };